import { render, staticRenderFns } from "./AppNotificationItem.vue?vue&type=template&id=860b5b7c&"
import script from "./AppNotificationItem.vue?vue&type=script&lang=js&"
export * from "./AppNotificationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports